module.exports = __webpack_public_path__ + "img/jaime-perez.131fd3a6.jpg";